const state = {
  listaUnidadesProcedencia: undefined
}

export default state



// WEBPACK FOOTER //
// ./src/vuex/relatorios/state.js